import React, { Component, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Request from '../../utilities/Request';
import Tabs from '../components/Tabs';
import clearCaches from "../../utilities/clearCaches";
import ForgotPassword from "../components/login/ForgotPassword.jsx";
import { createdAccount, setPlayer, signedIn } from "../../redux/actions/dashboard.js";
import LoginContent from "../components/login/LoginContent.jsx";

export default function LoginPage() {
	const [email, updateEmail] = useState('');
	const [password, updatePassword] = useState('');
	const [showPassword, updateShowPassword] = useState(false);
	const [googleSignInError, updateGoogleSignInError] = useState(false);
	const [mainState, updateMainState] = useState(LoginPage.mainStates.login);
	const [googleSigningIn, updateGoogleSigningIn] = useState(false);
	const [submitting, updateSubmitting] = useState(false);
	const [error, updateError] = useState(null);

	const dispatch = useDispatch();
	const [currentTab, updateCurrentTab] = useState(LoginPage.tabs[0].to);

	const isLogin = currentTab === LoginPage.tabs[0].to;

	function cancelForgotPassword() {
		updateMainState(LoginPage.mainStates.login);
	}

	function forgotPasswordNavigate(event) {
		event.preventDefault();
		updateMainState(LoginPage.mainStates.forgot);
	}

	function toggleShowPassword() {
		updateShowPassword((prevState) => {
			return !prevState;
		});
	}

	function onSubmit(event) {
		event.preventDefault();

		console.log('is login?', currentTab, isLogin);
		const url = isLogin ? 'player/login' : 'player/sign_up';
		const data = { email, password };
		updateSubmitting(true);
		clearCaches()
			.then(() => {
				console.log('submitting login!');
				return Request.apiv1Post(url, data);
			})
			.then(_loginWithPlayerData)
			.catch(async(errorResponse) => {
				console.error(errorResponse);
				const error = await Request.parseError(errorResponse);
				console.log('parsed login error', error);
				updateError(error);
			})
			.finally(() => {
				updateSubmitting(false);
			});
	}

	async function _loginWithPlayerData(response) {
		return Promise.resolve()
			.then(() => {
				console.log('!!!!setplayer!!!!', response);
				dispatch(setPlayer(response.player));
				switch(response.login_type){
					case 'sign_up':
						dispatch(createdAccount())
						break;
					case 'log_in':
						dispatch(signedIn());
						break;
				};
			});
	}

	function inputChange(event) {
		const { name, value } = event.target;
		switch(name) {
			case 'email':
				updateEmail(value);
				break;
			case 'password':
				updatePassword(value);
				break;
			default: {
				throw new Error('need case for ' + name);
			}
		}
		updateError(null);
	}

	function onTabChange(label) {
		console.log('changed tab to', label);
		updateCurrentTab(label);
		// store.dispatch(setLoginPage(label));
		updateError(null);
	}

	function onGoogleSignInFailure() {
		const errorMessage = 'Something went wrong with the Google Sign In';
		updateGoogleSignInError(errorMessage);
		// this.unlisten();
	}

	function onGoogleSignIn(googleUser) {
		const authResponse = googleUser.getAuthResponse();
		console.log('the repsonse', authResponse);
		const { id_token: idToken } = authResponse;
		updateGoogleSigningIn(true);
		updateGoogleSignInError(null);
		Request.apiv1Post('player/google_sign_in', { id_token: idToken })
			.then((response) => {
				console.log('the response', response);
				return _loginWithPlayerData(response);
			})
			.catch((error) => {
				console.error(error);
			})
			.finally(() => {
				updateGoogleSigningIn(false);
			});
	}

	const loginContentProps = {
		email,
		password,
		showPassword,
		submitting,
		error,
		googleSignInError,
		googleSigningIn,
		currentTab,
		inputChange,
		forgotPasswordNavigate,
		onGoogleSignIn,
		onGoogleSignInFailure,
		onSubmit
	};

	return (
			<div className='login_page'>
				<div>
					<h4 className='center'>Untitled Budget</h4>
				</div>
				{/*<div className='row front_logo_container section'>*/}
				{/*	<img src={`${siteUrl}/images/icon128.png`} className='front_logo center' />*/}
				{/*</div>*/}
				<div>
					<div className='section'>
						{mainState === LoginPage.mainStates.login &&
						<Tabs
							onTabChange={onTabChange}
							activeTab={currentTab}
						>
							{LoginPage.tabs.map((tab) => (
								<div
									key={tab.to}
									label={tab.to}
									content={tab.text}
								>
									<LoginContent
										{...loginContentProps}
									/>
								</div>
							))}
						</Tabs>
						}
						{mainState === LoginPage.mainStates.forgot &&
						<ForgotPassword
							cancelForgotPassword={cancelForgotPassword}
						/>
						}
					</div>
				</div>
			</div>
	);
}
LoginPage.tabs = [
	{ to: 'login', text: 'Log In' },
	{ to: 'sign-up', text: 'Sign Up' },
];
LoginPage.mainStates = {
	login: 'login',
	forgot: 'forgot',
};